import { Button, Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import WushTextField from "../WushTextField";
import useLocationStore from "../../../stores/useLocationStore";
import useAlertStore from "../../../stores/useAlertStore";
import create from "../../../api/auth/locations/create";
import update from "../../../api/auth/locations/update";
import WushStateSelect from "../WushStateSelect";

export default function LocationForm({ location, afterUpdate, afterCreate }) {
  const { updateLocation, addLocation } = useLocationStore();
  const { setAlertMessage } = useAlertStore();

  const { register, handleSubmit, reset, formState: { isDirty } } = useForm();

  const onSubmit = (data) => {
    if(location?.id) {
      update(location.id, data, (response) => {
        updateLocation(response);
        setAlertMessage("Location updated successfully", "success");
        afterUpdate && afterUpdate(response);
      }, (error) => {
        console.log(error);
      });
    } else {
      create(data, (response) => {
        addLocation(response);
        reset();
        afterCreate && afterCreate(response);
      }, (error) => {
        console.log(error);
      });
    }
  };

  return (
    <Stack>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack mb={2}>
          <WushTextField formRegistration={register("name")} label="Name" defaultValue={location?.name} />
        </Stack>
        <Stack mb={2}>
          <WushTextField formRegistration={register("description")} label="Description" defaultValue={location?.description} />
        </Stack>
        <Stack mb={2}>
          <WushTextField formRegistration={register("address_1")} label="Address Line One" defaultValue={location?.address_1} />
        </Stack>
        <Stack mb={2}>
          <WushTextField formRegistration={register("address_2")} label="Address Line Two" defaultValue={location?.address_2} />
        </Stack>
        <Stack direction="row" gap={2}>
          <Stack mb={2}>
            <WushTextField formRegistration={register("city")} label="City" defaultValue={location?.city} />
          </Stack>
          <Stack mb={2}>
            <WushStateSelect formRegistration={register("state")} label="State" defaultValue={location?.state} />
          </Stack>
          <Stack mb={2}>
            <WushTextField formRegistration={register("zip")} label="Zip" defaultValue={location?.zip} />
          </Stack>
        </Stack>
        <Stack direction="row">
          <Button disabled={!isDirty} variant="contained" type="submit">{location?.id ? "Update" : "Create"}</Button>
        </Stack>
      </form>
    </Stack>
  );
}